import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPaginationModule, PaginatePipe } from 'ngx-pagination';

import { PagingTemplateComponent } from './components/paging-template/paging-template.component';
import { SortIconClassPipe } from './pipes/sort-icon-class.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ValidatableBaseComponentComponent } from './components/base-components/validatable-base-component/validatable-base-component.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';


@NgModule({
   declarations: [PagingTemplateComponent, SortIconClassPipe, ValidatableBaseComponentComponent, PagenotfoundComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        NgxPaginationModule,
		NgMultiSelectDropDownModule.forRoot()
    ],

    exports: [
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatTooltipModule,
        NgxPaginationModule,
        PagingTemplateComponent,
		ValidatableBaseComponentComponent,
        SortIconClassPipe,
		NgMultiSelectDropDownModule
    ]
})
export class SharedModule { }
